import React, { useState, useRef, useEffect } from 'react';
import placeholderImage from '../../assets/profile-image.png';
import { Button } from "@cpnw/ui";
import PropTypes from 'prop-types';
import styles from './DashboardDemographicsImage.module.css';
import classNames from 'classnames';

const DashboardDemographicsImage = ({ changeImageItem, image, btnDisabled }) => {
  const [imagePreview, setImagePreview] = useState(image || placeholderImage);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      changeImageItem(file);
    };
    reader.readAsDataURL(file);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (image) {
      setImagePreview(image);
    }
  }, [image]);

  return (
    <div className={styles.container}>
      {imagePreview && <img src={imagePreview} alt="Preview" style={{ marginTop: '10px', marginBottom: '15px', width: '100%', maxWidth: '100%' }} />}
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: 'none' }}
        ref={fileInputRef}
        id="upload-image"
      />
      <Button className={classNames(styles.square_button, !btnDisabled && styles.hover)} text="Upload File" onClick={handleButtonClick} disabled={btnDisabled}/>
    </div>
  );
};

DashboardDemographicsImage.propTypes = {
  changeImageItem: PropTypes.func.isRequired,
  image: PropTypes.string,
  btnDisabled: PropTypes.bool,
};

export default DashboardDemographicsImage;



